import { render, staticRenderFns } from "./UpdateFailView.vue?vue&type=template&id=deb1b2a6"
import script from "./UpdateFailView.vue?vue&type=script&lang=js"
export * from "./UpdateFailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports